import { Component, inject } from '@angular/core';
import { IonLabel, IonSegment, IonSegmentButton } from '@ionic/angular/standalone';
import { LanguageSwitcherStore } from '@libs/mtjr/shared/i18n/language-switcher.store';

@Component({
  selector: 'mtjr-language-switcher',
  standalone: true,
  imports: [IonSegment, IonSegmentButton, IonLabel],
  template: `
    <ion-segment value="buttons" mode="ios" [value]="store.currentLang()" (ionChange)="setLanguage($event)">
      @for (lang of store.supportedLanguages(); track $index) {
        <ion-segment-button [value]="lang">
          <ion-label>{{ lang.name }}</ion-label>
        </ion-segment-button>
      }
    </ion-segment>
  `,
})
export class LanguageSwitcherComponent {
  store = inject(LanguageSwitcherStore);

  setLanguage(event: CustomEvent) {
    // add delay to avoid immediate reload
    setTimeout(() => {
      if (event.detail.value === this.store.currentLang()) return; // no change, do nothing
      this.store.setLanguage(event.detail.value);
    }, 300);
  }

  constructor() {
    const lang = this.store.currentLang();
    if (lang) {
      document.documentElement.dir = lang.dir;
      document.documentElement.lang = lang.code;
    }
  }
}
